import { render, staticRenderFns } from "./addGift.vue?vue&type=template&id=4c567716&scoped=true&"
import script from "./addGift.vue?vue&type=script&lang=js&"
export * from "./addGift.vue?vue&type=script&lang=js&"
import style0 from "./addGift.vue?vue&type=style&index=0&id=4c567716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c567716",
  null
  
)

component.options.__file = "addGift.vue"
export default component.exports